import { Injectable } from "@angular/core";
import { OrderPayload } from "../meta/OrderPayload.type";
import { Md5 } from "ts-md5"
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: "root"
  })
  export class OrderService {

    private hash: string | null = null
    private orderNumber: string | null = null
    private readonly _salescode$ = new BehaviorSubject<string | null>(null)
    public readonly salescode$ = this._salescode$.asObservable()

    private getHash(payload: OrderPayload): string {
        return Md5.hashStr(JSON.stringify(payload))
      }
    
    public getOrderNumber(payload: OrderPayload): string {
        const hash = this.getHash(payload)
        if (hash === this.hash) {
            this.orderNumber
        }
        this.hash = hash
        this.orderNumber = `${Math.round(Date.now() / 1000) - 1609455600}-${hash.substring(hash.length - 4)}`
        return this.orderNumber
    }

    public getSalescode(): string |  null {
      return this._salescode$.getValue()
    }

    public setSalescode(salescode: string | null) {
      this._salescode$.next(salescode)
    }
  
 }
